export const totemStatus = {
  EXPIRED: "expired",
  ACTIVE: "active",
  INACTIVE_PENDING: "inactivePending",
  INACTIVE_CONFIRMED: "inactiveConfirmed",
};
